import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

export default function ProgressBar({level, steps}) {
  const currentStep = steps[level]
  const progressBar = ((level + 1) / steps.length) * 100 - 1
  return (
    <div className={styles.container}>
      <div className={styles.stepProgression}>
        <div className={styles.stepTitle}>
          {currentStep.title}
        </div>
        <div className={styles.stepNumber}>
          {level + 1} de {steps.length}
        </div>
      </div>
      <div className={styles.progressBarContainer}>
        <div className={styles.progressBar} style={{width: `${progressBar}%`}}></div>
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  level: PropTypes.number,
  steps: PropTypes.array
}
